import { ChevronDown, Map } from "lucide-react";
import { useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { quests } from "../data/quests";
import { QuestIcon } from "./QuestIcon";
import "./GameMenu.css";

// The Games menu lists Night Before GFC last; other pages keep the catalogue order.
const navQuests = [...quests.filter((quest) => quest.id !== "night-before-gfc"), ...quests.filter((quest) => quest.id === "night-before-gfc")];

export function GameMenu({ hostMode = false }: { hostMode?: boolean }) {
  const location = useLocation();
  const menuRef = useRef<HTMLDetailsElement>(null);
  useEffect(() => { if (menuRef.current) menuRef.current.open = false; }, [location]);
  useEffect(() => {
    const closeOutside = (event: PointerEvent) => {
      if (menuRef.current && event.target instanceof Node && !menuRef.current.contains(event.target)) menuRef.current.open = false;
    };
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape" && menuRef.current?.open) {
        menuRef.current.open = false;
        menuRef.current.querySelector("summary")?.focus();
      }
    };
    document.addEventListener("pointerdown", closeOutside);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("pointerdown", closeOutside);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, []);

  function questHref(id: string, hostPath: string) {
    if (hostMode) return hostPath;
    const params = new URLSearchParams(location.pathname === "/" ? location.search : "");
    params.set("quest", id);
    return `/?${params.toString()}`;
  }

  return (
    <details className="game-menu" ref={menuRef}>
      <summary><Map size={16} aria-hidden="true" /> Games <ChevronDown className="menu-chevron" size={15} aria-hidden="true" /></summary>
      <div className="game-menu-panel">
        {navQuests.map(({ id, title, iconSrc, hostPath, tone }) => <Link key={id} to={questHref(id, hostPath)} className="game-menu-item" onClick={() => { if (menuRef.current) menuRef.current.open = false; }}>
          <span className={`game-menu-icon ${tone}`}><QuestIcon src={iconSrc} /></span><span><strong>{title}</strong></span>
        </Link>)}
      </div>
    </details>
  );
}
